/**
 * Configures AWS Amplify v6 Auth with the env-derived Cognito user
 * pool + client IDs. Side-effect import: importing this file is what
 * configures Amplify for the rest of the app.
 *
 * In dev/local these values come from `.env.local` (Vite reads them
 * at build time as `import.meta.env.VITE_*`). In deployed environments
 * they're injected by the FrontendStack's build step.
 */

import { Amplify } from "aws-amplify";

const userPoolId = (import.meta.env.VITE_COGNITO_USER_POOL_ID as string | undefined) ?? "";
const userPoolClientId =
  (import.meta.env.VITE_COGNITO_USER_POOL_CLIENT_ID as string | undefined) ?? "";

if (userPoolId && userPoolClientId) {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId,
        userPoolClientId,
        signUpVerificationMethod: "code",
        loginWith: {
          email: true,
        },
      },
    },
  });
} else if (typeof console !== "undefined") {
  console.warn(
    "[amplify] VITE_COGNITO_USER_POOL_ID or VITE_COGNITO_USER_POOL_CLIENT_ID " +
      "is not set; Amplify Auth is unconfigured. Sign-up/sign-in will fail.",
  );
}
